let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gUDkD")).then(() => parcelRequire('1fRy2'));